export default __webpack_public_path__ + "static/media/ht.fbf45023.jpg";